import React from "react";

export type ChoiceControlIconProps = {
  kind: "checkbox" | "radio";
  state: "unchecked" | "checked" | "indeterminate";
  /** MUI passes the control size to its icon. The 18px box is the same for every size. */
  fontSize?: string;
};

/**
 * The one checkbox and radio look of the staff dashboard (Monday 13396402468,
 * CMP Dashboard (24) L43-51). The cmpTheme MuiCheckbox and MuiRadio use it as
 * their icons and style it (theme.ts), so every MUI Checkbox and Radio shows
 * the design control. Staff screens use MUI Checkbox/Radio, never a native
 * checkbox or radio input (choiceControls.guard.test.ts).
 */
const ChoiceControlIcon = ({ kind, state }: ChoiceControlIconProps) => (
  <span aria-hidden="true" className={`cmp-choice-icon cmp-choice-icon--${kind} cmp-choice-icon--${state}`} />
);

export default ChoiceControlIcon;
